import React from 'react';
import { RealTimeContext } from './RealTimeContext';
/**
 * Provider component that wraps its children with the RealTimeContext.Provider
 * to make real-time functionality available throughout the component tree
 * @public
 */
export const RealTimeProvider = ({
  children,
  value
}) => {
  return React.createElement(RealTimeContext.Provider, {
    value: value
  }, children);
};